import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)

type Props = {
    videoRef:React.MutableRefObject<HTMLVideoElement>;
}
export const Reader: React.FC<Props> = (props) => {
  const ReaderDiv = styled.div`
    position: relative;
    display: none;
  `;

  const ReaderVideo = styled.video`
    background-color: #000;
    object-fit: fill;
  `;
return (
    <ReaderDiv>
        {/* <ReaderVideo id="js-video" autoPlay playsinline muted></ReaderVideo> */}
        <ReaderVideo ref={props.videoRef}  id="js-video" autoPlay={true} playsInline={true}></ReaderVideo>
    </ReaderDiv>
  );
};